import {
  LinearProgress,
  useMoiaSuccessNotification,
} from '@backoffice-frontend/patterns'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ActionCard } from '../ActionCard'

export const Departure = () => {
  const { t } = useTranslation()

  const [hasLoggedDeparture, setHasLoggedDeparture] = useState(false)

  const { enqueueMoiaSuccessNotification } = useMoiaSuccessNotification()

  useEffect(() => {
    if (!hasLoggedDeparture) {
      enqueueMoiaSuccessNotification(
        t('adFleetMap_vehicleClearedForDeparture_label'),
        { duration: 4000 },
      )
      setHasLoggedDeparture(true)
    }
  }, [hasLoggedDeparture, enqueueMoiaSuccessNotification, t])

  return (
    <ActionCard headline={t('adFleetMap_cscWaitingForDeparture_header')}>
      <LinearProgress />
    </ActionCard>
  )
}
